<template>
	<client-only fallback-tag="span">
		<template #fallback>
			<div class="invisible h-[22px]">...</div>
			<!--
            <v-placeholder class="h-[22px] w-24 rounded before:via-gray-200">
                .....
            </v-placeholder>
            -->
		</template>

		<div
			v-if="status === 'idle' || status === 'pending'"
			class="invisible h-[22px]"
		>
			...
		</div>
		<!--
        <v-placeholder v-if="status === 'idle' || status === 'pending'"
            class="h-[22px] w-24 rounded before:via-gray-200">
            .....
        </v-placeholder>
        -->

		<!-- eslint-disable tailwindcss/no-custom-classname -->
		<h-popover
			v-else-if="status === 'success'"
			class="review-stars relative"
			@mouseover="isOpen = true"
			@mouseleave="isOpen = false"
			@focusin="isOpen = true"
			@focusout="isOpen = false"
		>
			<!-- eslint-enable tailwindcss/no-custom-classname -->
			<h-popover-button
				class="flex flex-row items-center justify-center gap-2"
				:title="t('rating', {rating, max: 5, count: totalRatingCount})"
				@click="$emit('trigger')"
			>
				<!-- 'title' can be inconsistent for screen readers, hence the explicit rating text here -->
				<span class="sr-only">{{
					t("rating", {rating, max: 5, count: totalRatingCount})
				}}</span>

				<div class="flex items-center space-x-px">
					<v-icon
						v-for="i in 5"
						:key="i"
						class="fill-[#f6ca6c] stroke-brand-black"
						:icon="getIcon(i, rating)"
					/>
				</div>

				<span aria-hidden="true" class="text-sm text-gray-600">
					({{ totalRatingCount }})
				</span>
			</h-popover-button>

			<transition
				enter-active-class="transition duration-150"
				enter-from-class="opacity-0 -translate-y-2'"
				enter-to-class="opacity-100"
				leave-active-class="transition duration-150"
				leave-from-class="opacity-100"
				leave-to-class="opacity-0 -translate-y-2'"
			>
				<h-popover-panel
					v-if="isOpenDebounced"
					static
					class="absolute top-full left-1/2 z-10 w-64 -translate-x-1/2 bg-transparent pt-3"
				>
					<v-page-product-rating-tooltip
						:ratings="totalRatings"
						:total-rating-count="totalRatingCount"
						:skus="properties.skus"
						@click="$emit('trigger')"
					/>
				</h-popover-panel>
			</transition>
		</h-popover>
	</client-only>
</template>

<script setup lang="ts">
import {refDebounced} from "@vueuse/core";

import {useReviews} from "@pkg/shared/composables/use-reviews";

const properties = defineProps<{
	skus: string[];
}>();

defineEmits<{
	(event: "trigger"): void;
}>();

const {t} = useI18n();

const isOpen = ref(false);
const isOpenDebounced = refDebounced(isOpen, 300);

const {getReviews, getRating, getIcon} = useReviews();

const {status, totalRatings} = getReviews(
	properties.skus,
	1,
	"product-page-stars",
);

const {rating, totalRatingCount} = getRating(properties.skus);
</script>

<i18n lang="json">
{
	"et": {
		"rating": "Hinnang {rating} / {max} ({count} arvustust)"
	},
	"fi": {
		"rating": "Arvosana {rating} / {max} ({count} arvostelua)"
	}
}
</i18n>
